import React from "react";
import { X } from "lucide-react";
import { Button } from "../Button";
import { name } from "constants/config";

interface IModelProps {
  children: React.ReactNode;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  title?: string;
}

export const ModelCustom: React.FC<IModelProps> = ({
  isOpen,
  setIsOpen,
  children,
  title,
}) => {
  if (!isOpen) return null;

  return (
    <div className='fixed inset-0 z-10 flex items-center justify-center bg-black/40 '>
      <div className='bg-white rounded-xl w-[90vw] md:w-[75vw] max-w-[640px]  max-h-[80vh] overflow-y-auto mt-4 sm:mt-10 flex flex-col'>
        <div className='flex justify-between items-center sticky top-0 z-20 bg-white border-b border-theme400 px-3 sm:px-4 py-1 sm:py-2 rounded-t-xl'>
          <span className='text-[12px] sm:text-[14px] text-black font-medium'>
            {title}
          </span>
          <button
            onClick={() => setIsOpen(false)}
            className='p-1 hover:opacity-80 text-black hover:bg-theme100 hover:rounded-full duration-150'
          >
            <X className='w-5 h-5  ' />
          </button>
        </div>
        <div className='px-3 overflow-y-auto flex-1 pb-3 mt-2'>{children}</div>
      </div>
    </div>
  );
};
